import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2117f3f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-white shadow overflow-hidden sm:rounded-md w-full" };
const _hoisted_2 = { class: "block" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900 m-2 p-2" }, "Request Comments", -1));
const _hoisted_4 = { class: "px-4 py-4 flex items-center sm:px-6" };
const _hoisted_5 = { class: "w-full flex-1 sm:flex sm:items-center sm:justify-between" };
const _hoisted_6 = {
    key: 0,
    class: "flex flex-col w-full"
};
const _hoisted_7 = { class: "max-h-64 overflow-y-auto border-t border-gray-200" };
const _hoisted_8 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_9 = { class: "text-xs italic text-gray-400" };
const _hoisted_10 = { class: "rounded-md p-2 bg-gray-200 message-bubble" };
const _hoisted_11 = {
    key: 1,
    class: "my-2 flex flex-col self-end justify-end w-full items-end"
};
const _hoisted_12 = { class: "text-xs italic text-gray-400" };
const _hoisted_13 = { class: "rounded-lg w-full p-2 bg-green-700 message-bubble text-right text-white" };
const _hoisted_14 = {
    key: 2,
    class: "my-2"
};
const _hoisted_15 = { class: "text-xs italic text-gray-400" };
const _hoisted_16 = { class: "rounded-md p-2 bg-gray-200 message-bubble" };
const _hoisted_17 = {
    key: 3,
    class: "my-2 flex flex-col self-end justify-end w-full items-end"
};
const _hoisted_18 = { class: "text-xs italic text-gray-400" };
const _hoisted_19 = { class: "rounded-lg w-full p-2 bg-green-700 message-bubble text-right text-white" };
const _hoisted_20 = { key: 4 };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-gray-600 text-center mt-8 mb-2" }, "No comments to show...", -1));
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = { class: "flex overflow-hidden -space-x-1 mt-5 pt-8 border-t border-gray-200" };
const _hoisted_24 = ["disabled", "placeholder"];
const _hoisted_25 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.formData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                (_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyBudgetApproverComment`])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.firstLineApprover.approverEmail), 1),
                                        _createTextVNode(),
                                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyBudgetApproverComment`]), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                (_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyMoreInfoBudgetApprovalComment`])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.moreInfoComment.approverEmail), 1),
                                        _createTextVNode(),
                                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyMoreInfoBudgetApprovalComment`]), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                (_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyHROpsComment`])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.secondLineApprover.approverEmail), 1),
                                        _createTextVNode(),
                                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyHROpsComment`]), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                (_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyMoreNotifyHROpsComment`])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.moreInfoComment.approverEmail), 1),
                                        _createTextVNode(),
                                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyMoreNotifyHROpsComment`]), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                (!_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyBudgetApproverComment`] &&
                                    !_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyMoreInfoBudgetApprovalComment`] &&
                                    !_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyHROpsComment`] &&
                                    !_ctx.formData[`${_ctx.docType.toLowerCase()}.notifyMoreNotifyHROpsComment`])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "input-post-comment",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.inputValue) = $event)),
                                    disabled: !_ctx.showReply,
                                    name: "post-comment",
                                    type: "text",
                                    placeholder: !_ctx.showReply ? 'Cannot post comment when the request is not assigned to you' : 'Type your comment here...',
                                    class: "mr-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed"
                                }, null, 8, _hoisted_24), [
                                    [_vModelText, _ctx.inputValue]
                                ]),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    disabled: !_ctx.showReply || !_ctx.inputValue,
                                    class: "relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(
                                    //@ts-ignore
                                    (...args) => (_ctx.sendReply && _ctx.sendReply(...args)), ["prevent"]))
                                }, "\n                  Reply\n                ", 8, _hoisted_25)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
